<template>
  <div 
    class="placeholder"
    :class="[
      darkMode ? 'dark-mode' : ''
    ]"
    >
    {{ message }}

    <slot/>

    <Button
      v-if="withBackButton"
      label="Go back"
      color="black"
      size="large"
      icon="chevron-left" 
      @click="goBack"
      />
  </div>
</template>

<script>

import Button from "@/Components/Button"

export default {
  components: {
    Button
  },
  props: [
    'message',
    'darkMode',
    'withBackButton'
  ],
  methods: {
    goBack() {
      window.history.back()
    }
  
  }
}

</script>

<style lang="sass" scoped>

.placeholder
  width: 100%
  display: flex
  align-items: center
  justify-content: center
  border: 3px dashed rgba(#000, 0.1)
  text-align: center
  padding: 50px
  font-family: 'Roboto Condensed', sans-serif
  font-size: 22px
  font-weight: 400
  color: rgba(#000, 0.5)
  border-radius: 8px
  margin-bottom: 30px
  flex-direction: column
  gap: 20px

  &.dark-mode
    border: 3px dashed rgba(#fff, 0.1)
    color: rgba(#fff, 0.5)

  @media (max-width: 768px)
    font-size: 18px
    padding: 20px


</style>